
import { getAllSiteSettings } from './siteSettingsService';

export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
}

export interface SocialMediaLinks {
  whatsapp: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  twitter: string;
}

export async function getContactInfo(): Promise<ContactInfo> {
  try {
    const settings = await getAllSiteSettings();
    const contactMap = settings.reduce((acc, setting) => {
      acc[setting.key] = setting.value || '';
      return acc;
    }, {} as Record<string, string>);

    return {
      phone: contactMap['contact_phone'] || '+55 11 95114-2887',
      email: contactMap['contact_email'] || 'atendimento@telemarcas.com.br',
      address: contactMap['contact_address'] || 'Rua: Professor Antônio Gama de Cerqueira, 121  Centro São Miguel Paulista Cep: 08010130'
    };
  } catch (error) {
    console.error('Error fetching contact info:', error);
    return {
      phone: '+55 11 95114-2887',
      email: 'atendimento@telemarcas.com.br',
      address: 'Rua: Professor Antônio Gama de Cerqueira, 121  Centro São Miguel Paulista Cep: 08010130'
    };
  }
}

export async function getSocialMediaLinks(): Promise<SocialMediaLinks> {
  try {
    const settings = await getAllSiteSettings();
    const socialMap = settings.reduce((acc, setting) => {
      acc[setting.key] = setting.value || '';
      return acc;
    }, {} as Record<string, string>);

    return {
      whatsapp: socialMap['social_whatsapp'] || 'https://api.whatsapp.com/send?phone=5511951142887',
      instagram: socialMap['social_instagram'] || 'https://instagram.com/telemarcas',
      linkedin: socialMap['social_linkedin'] || 'https://linkedin.com/company/telemarcas',
      facebook: socialMap['social_facebook'] || 'https://facebook.com/telemarcas',
      twitter: socialMap['social_twitter'] || 'https://twitter.com/telemarcas'
    };
  } catch (error) {
    console.error('Error fetching social media links:', error);
    return {
      whatsapp: 'https://api.whatsapp.com/send?phone=5511951142887',
      instagram: 'https://instagram.com/telemarcas',
      linkedin: 'https://linkedin.com/company/telemarcas',
      facebook: 'https://facebook.com/telemarcas',
      twitter: 'https://twitter.com/telemarcas'
    };
  }
}